<template>
	<div class="ui-comparison-table">
		<div class="title">
			{{ title }}
			<slot name="title" />
		</div>

		<div class="table-container">
			<table class="table">
				<thead class="table-thead">
					<tr>
						<td v-for="(td, index) in theadComputed" :key="index" v-html="td"></td>
					</tr>
				</thead>

				<tbody class="table-tbody">
					<tr v-for="(tr, index) in tbodyComputed" :key="index">
						<td v-for="(td, index) in tr" :key="index" v-html="td"></td>
					</tr>
					<tr>
						<td v-for="(td, index) in theadComputed" :key="index">&nbsp;</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				required: false,
				default: '',
			},

			table: {
				type: [Object, Array],
				required: true,
				default: () => {},
			},
		},

		data() {
			return {}
		},

		computed: {
			theadComputed() {
				return this.table.thead
			},

			tbodyComputed() {
				return this.table.tbody
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
